import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

/* eslint-disable import/prefer-default-export */
import React from 'react';
import styled from 'styled-components'; // @ts-ignore

import { localizeDate } from '@kargotech/tms-common/Utilities/date';
import Space from '../Space';
import Typography from '../Typography';
import Timeline, { ZoneElement } from '../Timeline';
export var Header = styled(Typography.Text).attrs(function (props) {
  return {
    block: 'true',
    strong: 'true',
    children: props.title
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["&& {\n  margin-bottom: 1rem;\n  margin-top: 1rem;\n}"])));
var dot = /*#__PURE__*/React.createElement("span", {
  style: {
    fontSize: '2rem'
  }
}, " \u2022 ");
export var Detail = function Detail(_ref) {
  var dataTestId = _ref['data-testid'],
      timestamp = _ref.timestamp,
      text = _ref.text,
      onViewChanges = _ref.onViewChanges,
      children = _ref.children,
      timelineItemProps = _ref.timelineItemProps;
  return /*#__PURE__*/React.createElement(Timeline.Item, _extends({
    "data-testid": dataTestId,
    dot: dot,
    tailcolor: "darkGrey"
  }, timelineItemProps), /*#__PURE__*/React.createElement("header", null, /*#__PURE__*/React.createElement(Space, {
    direction: "horizontal",
    justify: "space-between"
  }, /*#__PURE__*/React.createElement(ZoneElement, {
    fontSize: "medium",
    zoneScheme: "dark"
  }, /*#__PURE__*/React.createElement(Typography.Text, {
    className: "hover-bold"
  }, text)), typeof onViewChanges === 'function' && /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement(Typography.Link, {
    onClick: onViewChanges
  }, "View Changes")))), /*#__PURE__*/React.createElement("main", null, children), /*#__PURE__*/React.createElement("footer", {
    className: "timeline-subtitle"
  }, /*#__PURE__*/React.createElement(ZoneElement, {
    fontSize: "medium",
    zoneScheme: "darkGrey"
  }, localizeDate(timestamp))));
};
export default {
  Header: Header,
  Detail: Detail
};